import React from "react";
import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

export default function Pagination({
  page,
  totalPages,
  onChange,
}) {
  if (totalPages <= 1) {
    return null;
  }

  const pages = [];

  for (let value = 1; value <= totalPages; value += 1) {
    if (
      value === 1 ||
      value === totalPages ||
      Math.abs(value - page) <= 1
    ) {
      pages.push(value);
    }
  }

  const compactPages = pages.reduce((acc, value, index) => {
    const previous = pages[index - 1];

    if (previous && value - previous > 1) {
      acc.push(`ellipsis-${value}`);
    }

    acc.push(value);

    return acc;
  }, []);

  return (
    <nav
      className="mt-8 flex flex-wrap items-center justify-center gap-2"
      aria-label="Pagination des annonces"
    >
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="flex h-11 items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:border-orange-300 hover:text-orange-600 disabled:opacity-40 dark:border-white/10 dark:bg-white/5 dark:text-slate-200"
      >
        <FaChevronLeft />
        <span className="hidden sm:inline">Précédent</span>
      </button>

      {compactPages.map((item) => {
        if (String(item).startsWith("ellipsis")) {
          return (
            <span
              key={item}
              className="px-2 text-slate-400"
            >
              …
            </span>
          );
        }

        const isActive = item === page;

        return (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={[
              "flex h-11 min-w-11 items-center justify-center rounded-xl border px-3 text-sm font-semibold transition",
              isActive
                ? "border-orange-500 bg-orange-500 text-white shadow-lg shadow-orange-500/20"
                : "border-slate-200 bg-white text-slate-700 hover:border-orange-300 hover:text-orange-600 dark:border-white/10 dark:bg-white/5 dark:text-slate-200",
            ].join(" ")}
          >
            {item}
          </button>
        );
      })}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="flex h-11 items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:border-orange-300 hover:text-orange-600 disabled:opacity-40 dark:border-white/10 dark:bg-white/5 dark:text-slate-200"
      >
        <span className="hidden sm:inline">Suivant</span>
        <FaChevronRight />
      </button>
    </nav>
  );
}